import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router } from '@angular/router';
import { RedirectService } from '@piqet-angular/shared';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class ActivationCodeGuard implements CanActivate {
  constructor(
    private router: Router,
    private cookieService: CookieService,
    private redirectService: RedirectService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const activationCode = route.queryParams['activationCode']?.trim();
    const UID = route.queryParams['UID']?.trim();
    const trialCode = route.queryParams['trialCode']?.trim();
    const token = this.cookieService.get('token');

    if (activationCode || UID || trialCode) {
      if (UID && !token) {
        this.redirectService.setRedirectUrl(state.url);
        this.router.navigate(['/login']);
        return false;
      }
      return true;
    }

    this.router.navigate(['/login']);
    return false;
  }
}
